import { createUseStyles } from 'react-jss'

export default createUseStyles({
  previewWrapper: {
    marginTop: 24
  },
  linkPreview: {
    lineBreak: 'anywhere'
  }
})
